"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_parent_1 = require("./fix$parent");
var funcParams_1 = require("./funcParams");
function validCalcFunction(rule, cache) {
    if (cache === void 0) { cache = true; }
    var s = '';
    if (typeof rule === 'string') {
        rule = fix_parent_1.default(rule);
        s = "return (" + rule + ")";
    }
    else if (Array.isArray(rule)) {
        for (var i = 0; i < rule.length; i++) {
            var item = rule[i];
            var ss = item.when || item.if || '';
            ss = fix_parent_1.default(ss);
            var ss2 = item.value;
            if (ss2 === undefined) {
                ss2 = ss;
            }
            else {
                if (typeof ss2 === 'string') {
                    ss2 = fix_parent_1.default(ss2);
                }
            }
            s += "if (" + ss + ") return (" + ss2 + ");";
        }
    }
    // console.log('create valid function', rule, s);
    return new Function(funcParams_1.default, s);
}
exports.default = validCalcFunction;
//# sourceMappingURL=validCalcFunction.js.map